import { Accordion } from '../../../../../components/general/accordion';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { LegalProceedingsHistoricalProps } from './props';
import { useLegalProceedingsHistorical } from './hook';
import { Table } from '../../../../../components/general/table';

export const LegalProceedingsHistorical = (
    historical: LegalProceedingsHistoricalProps
) => {
    const { columns, rows } = useLegalProceedingsHistorical(historical);
    return (
        <Accordion
            title="HISTÓRICO"
            icon={<ListAltIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Table
                columns={columns}
                rows={rows}
                rowCount={rows.length}
                pageSizeOptions={[10, 20, 50]}
                disableRowSelectionOnClick
            />
        </Accordion>
    );
};
